import React from 'react';
import { CHARTING_LAYOUTS, TChartingLayout } from 'types/chartingPreference';
import s from './s.module.less';

// The production session Layout menu thumbnails (Figma Telehealth 493:31882), shared by
// Calendar settings › Charting preferences and the session Layout menu.
const THUMBS: Record<TChartingLayout, React.ReactNode> = {
    CHART: (
        <>
            <rect width="38.51" height="16.2927" fill="currentColor" />
            <rect y="18.5146" width="38.51" height="16.2927" fill="currentColor" />
            <rect y="37.0283" width="38.51" height="16.2927" fill="currentColor" />
            <rect x="39.9912" width="13.3304" height="53.3215" fill="currentColor" />
        </>
    ),
    VIDEO: (
        <>
            <rect width="13.49" height="16.2927" fill="currentColor" />
            <rect y="18.5146" width="13.49" height="16.2927" fill="currentColor" />
            <rect y="37.0283" width="13.49" height="16.2927" fill="currentColor" />
            <rect x="15.4902" width="38.51" height="53.3215" fill="currentColor" />
        </>
    ),
    SIDE_BY_SIDE: (
        <>
            <rect width="25.9206" height="16.2929" fill="currentColor" />
            <rect y="18.5146" width="25.9206" height="16.2929" fill="currentColor" />
            <rect y="37.0283" width="25.9206" height="16.2929" fill="currentColor" />
            <rect x="28.1416" width="25.1796" height="53.3215" fill="currentColor" />
        </>
    ),
    FLOATING: (
        <>
            <rect width="53.3215" height="53.3215" fill="currentColor" />
            <rect x="24.4395" y="3.70312" width="25.9206" height="16.2929" fill="white" />
        </>
    ),
};

type Props = {
    value: TChartingLayout;
    onChange: (layout: TChartingLayout) => void;
    className?: string;
};

const ChartingLayoutPicker = ({ value, onChange, className }: Props) => {
    return (
        <div className={`${s.wrap} ${className || ''}`} role="radiogroup" aria-label="Default layout">
            {CHARTING_LAYOUTS.map(({ value: layout, label }) => (
                <button
                    key={layout}
                    type="button"
                    role="radio"
                    aria-checked={value === layout}
                    aria-label={label}
                    title={label}
                    className={`${s.tile} ${value === layout ? s.on : ''}`}
                    onClick={() => {
                        if (value !== layout) onChange(layout);
                    }}
                >
                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {THUMBS[layout]}
                    </svg>
                </button>
            ))}
        </div>
    );
};

export default ChartingLayoutPicker;
